import React, { useState, useEffect } from 'react';

import PageTitleNew from 'components/ui/PageTitleNew';

import DataTable from 'react-data-table-component';
import { Outlet } from 'react-router-dom';
import Filters from './Filters';

import columns from './columns';
import data from './data';

import { useContext } from '../../Context';

export default function Index() {
  const [keyword, setKeyword] = useState('');
  const [sessionType, setSessionType] = useState(null);
  const [enterprise, setEnterprise] = useState('');

  const { dispatch, actions, state } = useContext();

  useEffect(() => {
    if (state.token) {
      actions.load(dispatch, state.token);
    }
  }, [state.token])


  return (
    <div className="wrapper_assestment invite_wrapper">
      <PageTitleNew title="AI Sessions" />

      <div className="ibox-content mt20">
        <Filters
          keyword={keyword}
          setKeyword={setKeyword}
          sessionType={sessionType}
          setSessionType={setSessionType}
          enterprise={enterprise}
          setEnterprise={setEnterprise}
        />

        <div className="datatable-style">

          <DataTable
            title=""
            columns={columns}
            data={data(state.chats, keyword, sessionType, enterprise) || []}
            noDataComponent={(
              <div className="mt20">
                {state.chats == null
                  ? 'Please, wait ...'
                  : 'No matching records found'}
              </div>
            )}
            persistTableHead
            pagination
            paginationComponentOptions={{
              selectAllRowsItem: true,
              selectAllRowsItemText: 'All',
            }}
          />
        </div>
      </div>
      <Outlet />
    </div>
  );
}
